// extracted by mini-css-extract-plugin
export default {"root":"cJ07O8RgdKGNl3aPt9ny","wrap":"qGl4D5sgfOusTsbwsqn7","main":"gMVgbL9DMD267XWyjUM6","input":"w0R1zOw6OYuhkocSoa63"};